import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import AccommodationService from '../../services/AccommodationService';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import ActionLink from '../../components/ActionLink';
import YesNoDialog from '../../components/YesNoDialog';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CountryService from '../../services/CountryService';
import { Chip } from 'primereact/chip';
import CriteriaMultiSelectComponent from '../../components/criteria/CriteriaMultiSelectComponent';
import AccommodationCategoryService from '../../services/AccommodationCategoryService'
import { withRouter } from "react-router-dom";

class AccommodationListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new AccommodationService());

        this.state = {
            list: [],
            categories: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            dialogVisibile: false,
            deleteConfirmDialogVisible: false,
        };
        this.countryService = new CountryService();
        this.categoryService = new AccommodationCategoryService();
    }

    updateSearchCriteria(criteria) {
        return {
            login: criteria.login,
            firstName: criteria.firstName,
            lastName: criteria.lastName,
            roleType: criteria.roleType,
            status: criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            categories: criteria.categories
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',
            address: '',
            status: {
                enumValue: 'ACTIVE',
                label: t('AccommodationStatus.ACTIVE'),
            },
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
            categories: []
        };
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('AccommodationStatus')
            .then((statusOptions) => {
                statusOptions.forEach((o) => (o.label = t('AccommodationStatus.' + o.enumValue)));
                this.setState({
                    statusOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });

        this.categoryService
            .getList({ firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then((data) => this.setState({
                categories: data.content
            })).catch((err) => {
                this.unblockUi();
                this.showErrorMessage('Nie udało się pobrać listy krajów');
            });


        this.countryService
            .getAll()
            .then((countries) => {
                this.setState({
                    countries,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy krajów');
            });
    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_ACCOMMODATION_LIST_VIEW')
            ? [
                  {
                      label: t('accommodation.list.new'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleGoToNew,
                  },
              ]
            : [];
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('client.list.criteria.clientName')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaTextComponent
                    id='address-sc'
                    name='address'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.address}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('client.list.criteria.address')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />

                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('client.list.criteria.status')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    refreshFromBackend
                />
                <CriteriaMultiSelectComponent
                    id='categories'
                    name='categories'
                    label={t('accommodation.categories')}
                    colClass='col-md-4'
                    onChange={this.handleChangeSc}
                    options={this.state.categories}
                    optionLabel='name'
                    value={this.state.criteria.categories}
                    dataKey='id'
                    refreshFromBackend
                    timeoutHandler={this.refreshTimeLine}
                    filter
                    filterBy={'name'}
                />
            </div>
        );
    }

    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const href = `${detailUrl}/${rowData?.id}`;
        return (
            <span>
                {this.authService.isUserInRole('ROLE_ACCOMMODATION_VIEW') ? (
                <ActionLink
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={this.handleGoToDetail.bind(this, href)}
                    variant='blue'
                    className='edit-blue-link'
                    key={'view-button'}
                />
                ) : null}
                {this.authService.isUserInRole('ROLE_ACCOMMODATION_EDIT') ? (
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => this.handleOpenDeleteDialog(e, rowData)}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                    rendered={rowData.status.enumValue === 'ACTIVE'}
                />
                ) : null}
            </span>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }


    categoriesTemplate(rowData) {
        if (rowData?.categories) {
            return (
                rowData.categories.map(c => {
                    return (
                        <Chip style={{backgroundColor:c?.color?.value, color:"black"}} label={c.name} />
                    )
                })
            )
        } else {
            return '';
        }
    }

    prepareColumns() {
        const result = [
            {field: 'name', header: t('client.list.clientName'), sortable: true},
            {field: 'dateFrom', header: t('accommodation.dateFrom'), sortable: true},
            {field: 'dateTo', header: t('accommodation.dateTo'), sortable: true},
            {field: 'categories', header: t('accommodation.categories'), sortable: true, body: this.categoriesTemplate.bind(this)},
            {field: 'address.country.name', header: t('client.list.countryName'), sortable: true},
            {field: 'address.city', header: t('client.list.city'), sortable: true},
            {field: 'accommodationNumber', header: t('accommodation.number'), sortable: true},
            {field: 'status', header: 'Status', sortable: true, body: this.enumTemplate.bind(this, 'status')}
        ];
        if (this.authService.isUserInAnyRole('ROLE_ACCOMMODATION_VIEW', 'ROLE_ACCOMMODATION_EDIT')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            })
        }
        return result;
    }

    handleOpenDeleteDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({deleteConfirmDialogVisible: true, element: rowData, dialogViewMode: 'DELETE'});
    }

    handleDelete(e) {
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.element);
        this.service
            .remove(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('accommodation.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('accommodation.deleteError'));
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({deleteConfirmDialogVisible: false});
            });
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid'>
                <BreadcrumbsItem to='/accommodation-list'>{t('client.listName')}</BreadcrumbsItem>
                {this.renderView()}
                {this.state.deleteConfirmDialogVisible ? (
                    <YesNoDialog
                    visible={this.state.deleteConfirmDialogVisible}
                    header={t('accommodation.header.delete')}
                    name='visible'
                    onChange={(type, x, target) => {
                        if (target.value) {
                            this.handleDelete();
                        } else {
                            this.setState({deleteConfirmDialogVisible: false})
                        }
                    }}
                    onHide={() => this.setState({deleteConfirmDialogVisible: false})}
                     >
                        {t('details.deleteConfirmation') + '\n' + this.state.element?.name}
                    </YesNoDialog>
                ) : null}
            </div>
        );
    }
}

AccommodationListContainer.defaultProps = {
    detailUrl: '/#/accommodation/details',
    newUrl: '/#/accommodation/create',
    lazy: true,
};

AccommodationListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(AccommodationListContainer);
